import { createPackagePage } from '../../../components/Packages'

const { PackagePage, getStaticPaths, getStaticProps } = createPackagePage('en')
export { PackagePage as default, getStaticPaths, getStaticProps }
